// extracted by mini-css-extract-plugin
export default {"dataCenterCard":"DataCenters_dataCenterCard__xLnvu","dataCentersCancelButton":"DataCenters_dataCentersCancelButton__S8kg2"};